import { format } from "date-fns";

declare var Tafgeet: any;

export const printRecipts = (
  { base, system },
  document: any = {},
  reservation: any = {},
  receipt: any = {},
) => {
  // constants
  const layout: any = {
    // letterhead: "ww-letterhead.jpg",
    letterhead: "",
  };

  const today = new Date().toISOString().slice(0, 10);

  function formatCurrency(amount) {
    return amount.toLocaleString("en-US");
  }

  const selling_date = document.created_at;

  return `<!DOCTYPE html>
  <html lang="ar" dir="rtl">
    <head>
      <meta charset="UTF-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>${document.name}</title>


      <style>
        @font-face {
          font-family: "Cairo";
          src: url(${base}assets/fonts/Cairo-VariableFont_slnt,wght.ttf);
        }

        body {
          font-size: 12pt;
          background-image: url(${base}assets/img/${layout.letterhead});
          font-family: "Cairo";
          background-size: 100vw 100vh;
          line-height: 1.7rem;
        }
        pre {
          font-family: "Cairo";
        }

        .sm-text {
          font-size: 10pt !important;
        }

        h3, h4{
          margin: 0.7rem 0 !important;
        }

        .ml-3{
          margin-inline-end: 3rem !important;
        }

        .ml-1{
          margin-inline-end: 0.5rem !important;
        }

        .mr-3{
          margin-inline-start: 0.5rem !important;
        }

        .mt-3{
          margin-top: 0.7rem !important;
        }
          
        .mt-6{
          margin-top: 1.5rem !important;
        }

        .font-bold{
          font-weight: bold;
        }

        .text-center{
          text-align:center;
        }

        .p{
          line-height: 1.5rem;
        }

        .p1{
          line-height: 1rem;
        }
        
        .p2{
          line-height: 1.8rem;
        }

        .ltr {
          direction: ltr !important;
        }

        /* table classes */
        .table {
          width: 100%;
          margin-bottom: 1rem;
          color: #212529;
          border-collapse: collapse;
        }

        .table-bordered {
          border: 1px solid #dee2e6;
        }

        .table-bordered th,
        .table-bordered td {
          padding: 0.25rem 2rem !important;
          border: 1px solid #dee2e6;
          text-align: center;
          white-space: nowrap;
        }

        /* Flex utilities */
        .d-flex {
          display: flex;
        }
        
        .flex-row{
          flex-direction: row;
        }

        .flex-column{
          flex-direction: column;
        }

        .justify-content-between {
          justify-content: space-between;
        }

        .justify-content-end {
          justify-content: flex-end;
        }

       .flex-wrap{
          flex-wrap: wrap;
        }


        .underline{
          text-decoration: underline;
        }

        .justify-content-evenly {
          justify-content: space-evenly;
        }

        .justify-content-around {
          justify-content: space-around;
        }

        .justify-content-start {
          justify-content: flex-start;
        }

        .align-items-center {
          align-items: center;
        }

        .gap-4 {
          gap: 1rem;
        }

        .hr {
          width: 100%;
          border: 0;
          height: 0;
          border-top: 4px dotted rgba(0, 0, 0, 0.1);
          border-bottom: 4px dotted rgba(255, 255, 255, 0.3);
        }

        .grid {
          display: grid;
        }

        .grid-cols-4 {
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: 1rem;
        }

        .grid-cols-3 {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        .min-w-max {
            min-width: max-content;
        }

        .flex-wrap {
          flex-wrap: wrap;
        }

        .w-100{
          width: 100% !important;
        }

        .w-33{
          width: 33.333% !important;
        }

        .w-50{
          width: 50% !important;
        }

        .container {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }

        .item {
          flex: 0 0 calc(50% - 8px);
          box-sizing: border-box;
          padding-bottom: 20px;
        }

        .my-4{
          margin-top: 0.2rem !important;
          margin-bottom: 0.2rem !important;
        }

        p {
          display: block;
          width: max-content;
          font-size: 13px;
          margin-bottom: 0;
          margin-top: 0.5px;
        }

        .bt-2{
          border-top: 0.5px #000 dotted;
        }

        .left {
          float: left;
        }

        /* custom */

        @media print {
          * {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          footer {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 3rem;
          }

          .page {
            position: relative;
            padding-right: 1.5rem;
            padding-left: 1.5rem;
          }
        }
          
        @page {
          size: A4 portrait;
        }
      </style>
    </head>
    <body>
      <div class="page p">
        <div class="w-100 d-flex align-items-center justify-content-between">
          ${
            reservation.installment_logo
              ? `
              <img src="${reservation.installment_logo.url}" alt="" height="70" />
              `
              : ""
          }
          <h2 class="text-center">
            إيصال استلام نقدية / شيكات
          </h2>
          <h4 class="text-center">
            ${ receipt.serial }
          </h4>
        </div>
        <div class="w-100">
           <h4>
              التاريخ: ${new Date().toISOString().slice(0, 10)}
           </h4>
        </div>
        <div class="w-100 my-4 d-flex gap-4">
            <div class=" d-flex justify-content-start">
               <span>
                  ورد من السيد: ${ reservation.sharing_leads[0].lead_name }
               </span>
            </div>
            <div class=" d-flex justify-content-start">
               <span>
                 الرقم القومى / جواز السفر : ${ reservation.sharing_leads[0].lead_national_id ? reservation.sharing_leads[0].lead_national_id : "........................" }
               </span>
            </div>
        </div>
        <div class="w-100 my-4 d-flex gap-4">
            <div class="d-flex justify-content-start">
               <span>
                  مبلغ وقدره: ${ document.amount } جنيه مصري
               </span>
            </div>
            <div class="d-flex justify-content-start">
               <span>
                   فقط: (${ new Tafgeet(document.amount, "").parse() } جنيه مصري)
               </span>
            </div>
        </div>
        <div class="w-100 my-4 grid grid-cols-4">
            <div class="d-flex justify-content-start">
               ${
                 document.cheque_number
                   ? `
                   <span>
                      نقدا/ بشيك رقم: ${ document.cheque_number }
                   </span>
                   `
                   : ""
               }
               ${
                 document.transaction_number
                   ? `
                   <span>
                      نقدا/ بشيك رقم: ${ document.transaction_number }
                   </span>
                   `
                   : ""
               }
            </div>
            <div class="d-flex justify-content-start">
               <span>
                  
                    حق: ${ document.name? document.name : "........................" }
               </span>
            </div>
            <div class="d-flex justify-content-start">
               ${
                  document.bank
                   ? `
                   <span>
                      على بنك: ${ document.bank.name }
                   </span>
                   `
                   : ""
               }
            </div>
        </div>
        <div class="w-100 my-4 d-flex justify-content-start gap-4">
            <div class=" d-flex justify-content-start">
              ${
                document.type == 1
                  ? `
                  <span class="min-w-max">
                     دفعة مقدم من ثمن الوحدة رقم: ${ reservation.unit.serial }
                  </span>
                  `
                  : ""
              }
              ${
                document.type == 2
                  ? `
                  <span class="min-w-max">
                     وذلك قيمة: قسط من ثمن الوحدة رقم: ${ reservation.unit.serial }
                  </span>
                  `
                  : ""
              }
              ${
                document.type == 3
                  ? `
                  <span class="min-w-max">
                     وذلك قيمة: دفعة صيانة للوحدة رقم: ${ reservation.unit.serial }
                  </span>
                  `
                  : ""
              }
              ${
                document.type != 1 && document.type != 2 && document.type != 3
                  ? `
                  <span class="min-w-max">
                     وذلك قيمة: دفعة ${ document.name } للوحدة رقم: ${ reservation.unit.serial }
                  </span>
                  `
                  : ""
              }
            </div>
            <div class="d-flex justify-content-start">
               <span class="min-w-max">
                  بمشروع: ${ reservation.unit.project.name }
               </span>
            </div>
        </div>
        <div class="w-100 my-4 grid grid-cols-4">
            <div class="d-flex justify-content-start">
               <span>
                  إدارة الحسابات
               </span>
            </div>
            <div class="d-flex justify-content-start">
               <span>
                  ختم المشروع
               </span>
            </div>
            <div class="d-flex justify-content-start">
               <span>
                  المستلم
               </span>
            </div>
        </div>
        <div class="left my-4 d-flex flex-column justify-content-end">
            <p>
                لا يخل هذا الايصال بما للبائع من حقوق أخرى
            </p>
            <p>
                لا يعتد بالايصال إلا باستيفاء التوقيعات وختم المشروع
            </p>
            <p style="margin-bottom: 20px">
                تحريرا فى / ${ new Date().toISOString().slice(0, 10) }
            </p>
        </div>
        <hr class="hr" />
        <div class="w-100 d-flex align-items-center justify-content-between" style="margin-top: 0.5rem">
          ${
            reservation.installment_logo
              ? `
              <img src="${reservation.installment_logo.url}" alt="" height="70" />
              `
              : ""
          }
          <h2 class="text-center">
            إيصال استلام نقدية / شيكات
          </h2>
          <h4 class="text-center">
            <p>
              نسخة الإدارة
            </p>
            ${ receipt.serial }
          </h4>
        </div>
        <div class="w-100">
           <h4>
              التاريخ: ${new Date().toISOString().slice(0, 10)}
           </h4>
        </div>
        <div class="w-100 my-4 d-flex gap-4">
            <div class=" d-flex justify-content-start">
               <span>
                  ورد من السيد: ${ reservation.sharing_leads[0].lead_name }
               </span>
            </div>
            <div class=" d-flex justify-content-start">
               <span>
                 الرقم القومى / جواز السفر : ${ reservation.sharing_leads[0].lead_national_id ? reservation.sharing_leads[0].lead_national_id : "........................" }
               </span>
            </div>
        </div>
        <div class="w-100 my-4 d-flex gap-4">
            <div class="d-flex justify-content-start">
               <span>
                  مبلغ وقدره: ${ document.amount } جنيه مصري
               </span>
            </div>
            <div class="d-flex justify-content-start">
               <span>
                   فقط: (${ new Tafgeet(document.amount, "").parse() } جنيه مصري)
               </span>
            </div>
        </div>
        <div class="w-100 my-4 grid grid-cols-4">
            <div class="d-flex justify-content-start">
            ${
               document.cheque_number
                 ? `
                 <span>
                    نقدا/ بشيك رقم: ${ document.cheque_number }
                 </span>
                 `
                 : ""
             }
             ${
               document.transaction_number
                 ? `
                 <span>
                    نقدا/ بشيك رقم: ${ document.transaction_number }
                 </span>
                 `
                 : ""
             }
            </div>
            <div class="d-flex justify-content-start">
               <span>
                  
                    حق: ${ document.name? document.name : "........................" }
               </span>
            </div>
            <div class="d-flex justify-content-start">
               ${
                  document.bank
                   ? `
                   <span>
                      على بنك: ${ document.bank.name }
                   </span>
                   `
                   : ""
               }
            </div>
        </div>
        <div class="w-100 my-4 d-flex justify-content-start gap-4">
            <div class=" d-flex justify-content-start">
            ${
               document.type == 1
                 ? `
                 <span class="min-w-max">
                    دفعة مقدم من ثمن الوحدة رقم: ${ reservation.unit.serial }
                 </span>
                 `
                 : ""
             }
             ${
               document.type == 2
                 ? `
                 <span class="min-w-max">
                    وذلك قيمة: قسط من ثمن الوحدة رقم: ${ reservation.unit.serial }
                 </span>
                 `
                 : ""
             }
             ${
               document.type == 3
                 ? `
                 <span class="min-w-max">
                    وذلك قيمة: دفعة صيانة للوحدة رقم: ${ reservation.unit.serial }
                 </span>
                 `
                 : ""
             }
             ${
               document.type != 1 && document.type != 2 && document.type != 3
                 ? `
                 <span class="min-w-max">
                    وذلك قيمة: دفعة ${ document.name } للوحدة رقم: ${ reservation.unit.serial }
                 </span>
                 `
                 : ""
             }
            </div>
            <div class="d-flex justify-content-start">
               <span class="min-w-max">
                  بمشروع: ${ reservation.unit.project.name }
               </span>
            </div>
        </div>
        <div class="w-100 my-4 grid grid-cols-4">
            <div class="d-flex justify-content-start">
               <span>
                  إدارة الحسابات
               </span>
            </div>
            <div class="d-flex justify-content-start">
               <span>
                  ختم المشروع
               </span>
            </div>
            <div class="d-flex justify-content-start">
               <span>
                  المستلم
               </span>
            </div>
        </div>
        <div class="left my-4 d-flex flex-column justify-content-end">
            <p>
                لا يخل هذا الايصال بما للبائع من حقوق أخرى
            </p>
            <p>
                لا يعتد بالايصال إلا باستيفاء التوقيعات وختم المشروع
            </p>
            <p style="margin-bottom: 20px">
                تحريرا فى / ${ new Date().toISOString().slice(0, 10) }
            </p>
        </div>
        <hr class="hr" />
        <div class="w-100 d-flex align-items-center justify-content-between" style="margin-top: 0.5rem">
            ${
              reservation.installment_logo
                ? `
                <img src="${reservation.installment_logo.url}" alt="" height="70" />
                `
                : ""
            }
            <h2 class="text-center">
              إيصال استلام نقدية / شيكات
            </h2>
            <h4 class="text-center">
              <p>
                نسخة الحسابات
              </p>
              ${ receipt.serial }
            </h4>
          </div>
          <div class="w-100">
             <h4>
                التاريخ: ${new Date().toISOString().slice(0, 10)}
             </h4>
          </div>
          <div class="w-100 my-4 d-flex gap-4">
              <div class=" d-flex justify-content-start">
                 <span>
                    ورد من السيد: ${ reservation.sharing_leads[0].lead_name }
                 </span>
              </div>
              <div class=" d-flex justify-content-start">
                 <span>
                    الرقم القومى / جواز السفر: ${ reservation.sharing_leads[0].lead_national_id ? reservation.sharing_leads[0].lead_national_id : "........................" }
                 </span>
              </div>
          </div>
          <div class="w-100 my-4 d-flex gap-4">
              <div class="d-flex justify-content-start">
                 <span>
                    مبلغ وقدره: ${ document.amount } جنيه مصري
                 </span>
              </div>
              <div class="d-flex justify-content-start">
                 <span>
                     فقط: (${ new Tafgeet(document.amount, "").parse() } جنيه مصري)
                 </span>
              </div>
          </div>
          <div class="w-100 my-4 grid grid-cols-4">
              <div class="d-flex justify-content-start">
              ${
               document.cheque_number
                 ? `
                 <span>
                    نقدا/ بشيك رقم: ${ document.cheque_number }
                 </span>
                 `
                 : ""
             }
             ${
               document.transaction_number
                 ? `
                 <span>
                    نقدا/ بشيك رقم: ${ document.transaction_number }
                 </span>
                 `
                 : ""
             }
            </div>
            <div class="d-flex justify-content-start">
               <span>
                  
                    حق: ${ document.name? document.name : "........................" }
               </span>
            </div>
            <div class="d-flex justify-content-start">
               ${
                  document.bank
                   ? `
                   <span>
                      على بنك: ${ document.bank.name }
                   </span>
                   `
                   : ""
               }
            </div>
          </div>
          <div class="w-100 my-4 d-flex justify-content-start gap-4">
              <div class=" d-flex justify-content-start">
              ${
               document.type == 1
                 ? `
                 <span class="min-w-max">
                    دفعة مقدم من ثمن الوحدة رقم: ${ reservation.unit.serial }
                 </span>
                 `
                 : ""
             }
             ${
               document.type == 2
                 ? `
                 <span class="min-w-max">
                    وذلك قيمة: قسط من ثمن الوحدة رقم: ${ reservation.unit.serial }
                 </span>
                 `
                 : ""
             }
             ${
               document.type == 3
                 ? `
                 <span class="min-w-max">
                    وذلك قيمة: دفعة صيانة للوحدة رقم: ${ reservation.unit.serial }
                 </span>
                 `
                 : ""
             }
             ${
               document.type != 1 && document.type != 2 && document.type != 3
                 ? `
                 <span class="min-w-max">
                    وذلك قيمة: دفعة ${ document.name } للوحدة رقم: ${ reservation.unit.serial }
                 </span>
                 `
                 : ""
             }
              </div>
              <div class="d-flex justify-content-start">
                 <span class="min-w-max">
                    بمشروع: ${ reservation.unit.project.name }
                 </span>
              </div>
          </div>
          <div class="w-100 my-4 grid grid-cols-4">
              <div class="d-flex justify-content-start">
                 <span>
                    إدارة الحسابات
                 </span>
              </div>
              <div class="d-flex justify-content-start">
                 <span>
                    ختم المشروع
                 </span>
              </div>
              <div class="d-flex justify-content-start">
                 <span>
                    المستلم
                 </span>
              </div>
          </div>
          <div class="left my-4 d-flex flex-column justify-content-end">
              <p>
                  لا يخل هذا الايصال بما للبائع من حقوق أخرى
              </p>
              <p>
                  لا يعتد بالايصال إلا باستيفاء التوقيعات وختم المشروع
              </p>
              <p style="margin-bottom: 20px">
                  تحريرا فى / ${ new Date().toISOString().slice(0, 10) }
              </p>
          </div>
      </div>
    </body>
  </html>
  `;
};



// WEBPACK FOOTER //
// ./src/app/reservation-view/prints/recipts.ts